import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { ApiParams } from '../../helpers/apiHelpers';
import { AssignedWireType } from '@/types/wireTypes';

export const getDepositorWiresApi = (
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<AssignedWireType>>> => {
  const uri = `/depositor/wires/`;

  return authApiService.GET(uri, params);
};
